import { PropsWithChildren, ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';

interface ISwitchProps {
  notFound: ReactElement;
}

export const SwitchWithNotFound = ({ children, notFound: NotFound }: PropsWithChildren<ISwitchProps>): ReactElement => (
  <Switch>
    {children}
    <Route>{NotFound}</Route>
  </Switch>
);
